import { DetailsLightCss, h5 } from "@/styles/typography";
import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";
import { Link as GatsbyLink } from "gatsby";

const Footer = styled.footer`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.primaryPurple};
  padding: 48px 16px;
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 48px 42px;

    .div1 {
      grid-area: 1 / 1 / 2 / 2;
    }
    .div2 {
      grid-area: 2 / 1 / 3 / 6;
    }
    .div3 {
      grid-area: 3 / 1 / 4 / 6;
    }
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding: 60px 72px;

    display: grid;
    grid-template-columns: repeat(auto, 1fr);
    grid-template-rows: repeat(2, 1fr);
    grid-column-gap: 72px;
    grid-row-gap: 200px;
    height: 550px;

    .div1 {
      grid-area: 1 / 1 / 2 / 2;
    }
    .div2 {
      grid-area: 1 / 2 / 2 / 6;
    }
    .div3 {
      grid-area: 2 / 1 / 3 / 6;
    }
  }

  @media print {
    display: none;
  }
`;

const LogoWrapper = styled.div``;

const Logo = styled(GatsbyImage)`
  max-width: 143px;
`;

const ColumnsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
    gap: 72px;
  }
`;

const Column = styled.div``;

const ColumnTitle = styled(h5)`
  color: ${({ theme }) => theme.colors.coreLight};
  margin-bottom: 16px;
`;

const LinksWrapper = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const LinkItem = styled.li``;

const Link = styled(GatsbyLink)`
  ${DetailsLightCss}
  text-decoration: none;
  color: ${({ theme }) => theme.colors.coreLight};
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: 0.3s;

  &:hover {
    text-decoration-color: ${({ theme }) => theme.colors.coreLight};
  }
`;

const ExternalLink = styled.a`
  ${DetailsLightCss}
  text-decoration: none;
  color: ${({ theme }) => theme.colors.coreLight};
  text-decoration: underline;
  text-decoration-color: transparent;
  transition: 0.3s;

  &:hover {
    text-decoration-color: ${({ theme }) => theme.colors.coreLight};
  }
`;

const SoMeWrapper = styled.div`
  display: flex;
  gap: 24px;
`;

const SoMeLink = styled.a``;

const IconWrapper = styled.div``;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  div {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
    gap: 72px;
    justify-content: space-between;
    width: 100%;

    div {
      flex-direction: row;
    }
  }
`;

const InfoText = styled.span`
  ${DetailsLightCss}
  color: ${({ theme }) => theme.colors.coreLight};
`;

const S = {
  Footer,
  LogoWrapper,
  Logo,
  ColumnsWrapper,
  Column,
  ColumnTitle,
  LinksWrapper,
  LinkItem,
  Link,
  ExternalLink,
  SoMeWrapper,
  SoMeLink,
  IconWrapper,
  InfoWrapper,
  InfoText,
};

export default S;
